module.exports = __webpack_public_path__ + "img/LoginGenes.7b02bd5e.jpg";